import { render } from "./slide.vue?vue&type=template&id=2f1f7942&scoped=true"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"

import "./slide.vue?vue&type=style&index=0&id=2f1f7942&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1f7942"]])

export default __exports__